var ajaxurl = GEXP.ajaxurl;
var startDate = formatDateForPhpUse(new Date());
var endDate = startDate;
var reportDay = 'For Today';
var carReport = '';
var eventReport = '';
var totalPreEventUpsell = 0;
var todayEventupsell = 0;
var overallTotal = 0;
var allBookings = 0;
var adultBookings = 0;
var juniorBookings = 0;
var event_table_key = 0;
var event_table_val = 0;
var eventTableUrl = '';
var EventCheckinTable = '';
var PaymentTable = '';
var DeletePaymentTable = '';
var addonObject = {};
var existing_order_id = 0;
var subtotal = 0;
var discount = 0;
var total = 0;
var voucherTitle = '';
var voucherProductId = '';
var voucherPrice = '';
var addOnProduct = [];
var addonSelectedslug = '';
var orderItems = {};
var orderVoucherItems = {};
var merchItems= {};
var errorMsg = 'Error';
var orderCompleted = false;

function resetAddonObject() {
	addonObject = {}
}

function resetVoucherObject() {
	orderVoucherItems = {};
}

// function resetOrderId() {
//   existing_order_id = 0;
// }

$("#addon-form").submit(function (e) {
	e.preventDefault();
});

function formatDateForPhpUse(date) {
	if (typeof date == "string") {
		date = new Date(date);
	}
	let year = date.getFullYear();
	let month = (1 + date.getMonth()).toString();
	month = month.length > 1 ? month : '0' + month;
	let day = date.getDate().toString();
	day = day.length > 1 ? day : '0' + day;

	return year + '-' + month + '-' + day;
}

function formatDateForUI(date) {
	if (typeof date == "string") {
		date = new Date(date);
	}
	let year = date.getFullYear();
	let month = (1 + date.getMonth()).toString();
	month = month.length > 1 ? month : '0' + month;
	let day = date.getDate().toString();
	day = day.length > 1 ? day : '0' + day;

	return day + '/' + month + '/' + year;
}

$("body #admin-panel").ready(function () {
	const urlSearchParams = new URLSearchParams(window.location.search);
	const params = Object.fromEntries(urlSearchParams.entries());
	if (params.action === 'pos-admin') {
		getAdminData(startDate, endDate);
	}
});

function getAdminData(startDate, endDate, reload = false) {
	let start = startDate;
	let end = endDate;
	let data = {
		"action": "pos",
		"post_action": "get_overall_admin_data",
		"filters": { 'start': start, 'end': end }
	}
	let adminAjax = $.post(ajaxurl, data);
	adminAjax.done(function (response) {
		let result = JSON.parse(response);
		populateOverallFields(result.data);
	});
	let eventDataURL = ajaxurl + '?action=pos&post_action=get_admin_event_report&start=' + start + '&end=' + end + '';
	let carDataUrl = ajaxurl + '?action=pos&post_action=get_admin_car_report&start=' + start + '&end=' + end + '';
	if (reload) {
		eventReport.ajax.url(eventDataURL).load();
		carReport.ajax.url(carDataUrl).load();
		reportDay = "From " + start + " to " + end;
	} else {
		eventReport = $('#eventTableAdmin').DataTable({
			dom: 'rtp',
			pageLength: 12,
			ajax: { url: eventDataURL },
			responsive: true,

		});
		carReport = $('#carTableAdmin').DataTable({
			dom: 'rtp',
			pageLength: 12,
			ajax: { url: carDataUrl },
			responsive: true,
		});
	}
	$("#report-heading").html("Report " + reportDay);
}

function populateOverallFields(data) {
	totalPreEventUpsell = parseFloat(data.pre_event_upsell);
	todayEventupsell = parseFloat(data.today_event_upsell);
	allBookings = data.all_bookings;
	juniorBookings = data.junnior_bookings;

	adultBookings = Number(allBookings) - Number(juniorBookings);
	$("#addonListForAdmin").html(data.addon_list_string);
	$(".allBookings").html('/ ' + allBookings);
	$("#adultBookings").html(adultBookings);
	$("#juniorBookings").html(juniorBookings);
	overallTotal = totalPreEventUpsell + todayEventupsell;
	$("#totalSell").html('£' + overallTotal.toFixed(2));
	$("#totalDisq").html('£' + parseFloat(data.today_discount).toFixed(2));
	$("#eventUpsell").html('£' + todayEventupsell);
	$("#preEventUpsell").html('£' + totalPreEventUpsell);
}

var swiper = new Swiper(".mySwiper", {
	slidesPerView: "auto",
	spaceBetween: 8,
	observer: true
});

(function ($) {

	var posCal;
	var config = {
		inline: true,
		mode: "range",
		showMonths: 1,
		dateFormat: "Y-m-d",
		disableMobile: "true",
		onChange: function (date, str, inst) {
			startDate = formatDateForPhpUse(date[0]);
			if (date.length > 1) {
				endDate = formatDateForPhpUse(date[1]);
			} else {
				endDate = startDate;
			}
			$(".getDateRangeResult").addClass("btn-covey");
		},
		locale: {
			weekdays: {
				shorthand: ["S", "M", "T", "W", "T", "F", "S"],
				longhand: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
			}
		}
	}

	var config2 = {
		inline: false,
		mode: "single",
		showMonths: 1,
		dateFormat: "Y-m-d",
		disableMobile: "true",
		onChange: function (date, str, inst) {
			startDate = formatDateForPhpUse(date[0]);
			if (date.length > 1) {
				endDate = formatDateForPhpUse(date[1]);
			} else {
				endDate = startDate;
			}
		}
	}

	function initPosCal() {
		if (!posCal) {
			posCal = $('#posCalender').flatpickr(config);
		}
	}

	var selectedEvents = ['dates', 'item'];
	selectedEvents['item'] = [];

	var staff_portal_page = document.getElementById("section-staff-portal");
	if (staff_portal_page) {
		let staffid = $("#logged_staff_id").val();
		let data = {
			"action": "pos",
			"post_action": "get_staff_calender_data",
			"filters": { 'staff': staffid }
		}
		let calDataReq = $.post(ajaxurl, data);
		calDataReq.done(function (response) {
			let result = JSON.parse(response);
			let dates = [];
			let locationDates = [];
			let eventids = [];
			for (let i = 0; i < result.data.length; i++) {
				let currentDate = result.data[i];
				dates.push(currentDate.date);
				if (typeof locationDates[currentDate.location] === 'undefined') {
					locationDates[currentDate.location] = [];
				}
				locationDates[currentDate.location].push(currentDate.date);

				if (typeof eventids[currentDate.location] === 'undefined') {
					eventids[currentDate.location] = [];
				}
				eventids[currentDate.location].push(currentDate.id);
			}

			const config3 = {
				inline: true,
				mode: "multiple",
				showMonths: 1,
				dateFormat: "d/m/Y",
				disableMobile: "true",
				enable: dates,
				onChange: function (date, str, inst) {
					callF(inst);
				},
				onDayCreate: function (dObj, dStr, fp, dayElem) {

					let day = ('0' + dayElem.dateObj.getDate()).slice(-2);
					let month = ('0' + (dayElem.dateObj.getMonth() + 1)).slice(-2);
					let date = day + '/' + month + '/' + dayElem.dateObj.getFullYear();
					for (var key in locationDates) {
						if (locationDates[key].indexOf(date) != -1) {
							dayElem.className += ' ' + key;
							dayElem.setAttribute('event-id', eventids[key]);
						}
					}
				}
			}
			eventCal = flatpickr("#eventSelect", config3);
		});
	}

	function callF(instance) {
		let countSelected = 0;
		let classes = instance.selectedDateElem.classList;
		let item = classes.item(classes.length - 1);
		selectedEvents['dates'] = instance.selectedDates;
		selectedEvents['item'].push(item);
		let str = '';
		var i;
		for (i = 0; i < ObjectLength_Modern(selectedEvents['dates']); i++) {
			str += "<li>" + formatDateForUI(selectedEvents['dates'][i]) + "</li>";
			countSelected++;
		}
		if (str == '') {
			str += "<li> Select Available Date . </li>";
			$("#requestDate").removeClass('btn-covey').prop('disabled', true);
		} else {
			$("#requestDate").addClass('btn-covey').prop('disabled', false);
		}
		$(".shows-selections").html(str);
		$("#count-selected").html('(' + countSelected + ')');
	}

	var notification = '';
	$("#requestDate").click(function () {
		if ($(this).hasClass('btn-covey')) {
			if (ObjectLength_Modern(selectedEvents['dates']) > 0) {
				var datesArray = [];
				var i;
				for (i = 0; i < ObjectLength_Modern(selectedEvents['dates']); i++) {
					datesArray.push(formatDateForPhpUse(selectedEvents['dates'][i]));
				}
				$("#requestDate").removeClass('btn-covey').prop('disabled', true).html('Please Wait...');
				let data = {
					"action": "pos",
					"post_action": "staff_event_request_dates",
					"filters": { 'dates': datesArray }
				}
				let eventReq = $.post(ajaxurl, data);
				eventReq.done(function (response) {
					let result = JSON.parse(response);
					if (result.data) {
						$("#requestDate").html('Complete !');
						notification = "<div class='text-success'> Event Request Complete !  </div>";
						$(".request-container").html(notification);
						window.location.replace(window.location.origin + "/staff-portal/?action=my-events");
					}
				});
			}
		} else {
			notification = "<div class='text-danger'> No Date selected ! </div>";
			$(".request-container").html(notification);
		}
	});

	$("#calenderModal").on("shown.bs.modal", function () {
		initPosCal();
		$(".getDateRangeResult").removeClass("btn-covey");
	});

	$(".admin-panel").on("click", "#getDateRangeResult", function () {
		getAdminData(startDate, endDate, true);
		$("#calenderModal").modal('hide');
		$("#back-button").show();
	});

	$(".admin-panel").on("click", ".admin-product", function () {
		$(".product-highlight").addClass("product");
		$(".admin-product").removeClass("product-highlight");
		$(this).removeClass("product");
		$(this).addClass("product-highlight");
		$("#back-button").show();
		let pre_event_sell = parseFloat($(this).attr('data-remote-total'));
		let event_sell = parseFloat($(this).attr('data-local-total'));
		let event_total = pre_event_sell + event_sell;
		$("#totalSell").html('£' + event_total);
		$("#eventUpsell").html('£' + event_sell);
		$("#preEventUpsell").html('£' + pre_event_sell);
	});

	var addonswiper = new Swiper(".addonSwiper", {
		slidesPerView: 3,
		grid: {
			rows: 2,
		},
		spaceBetween: 7,
		breakpoints: {
			768: {
				slidesPerView: 4,
				spaceBetween: 7,
			},
			1024: {
				slidesPerView: 5,
				spaceBetween: 8,
			},
		},
	});

	function checkInputFieldsForAddonSell() {
		let returnValue = true;
		let driverName = $("#driver-name-input").val();

		if (driverName == '') {
			$("#driver-name-input").addClass('error');
			errorMsg = 'Check Driver Name';
			returnValue = false;
		} else {
			$("#driver-name-holder").html(driverName);
			$("#driver-name-input").removeClass('error');
		}

		//check receipt email
		if (!isReceiptEmailValid('card')) {
			returnValue = false;
		}

		return returnValue;
	}

	function checkInputFieldsForVouchers() {
		return true;
	}

	function checkInputFieldsForMerch() {
		return true;
	}

	$('#option-fields').on('click', '.form-check-inline', function () {
		$('input', '#option-fields').prop('checked', false);
		$('.form-check-input', $(this)).prop('checked', true);

	});

	function createFormReady(addon) {
		addonSelectedslug = addon.slug;
		$("#addon-name-holder").html(addon.name);
		if (addon.option == '1') {
			let string = '';
			let options = addon.option_details.split(',');
			var filtered = options.filter(function (el) {
				return el != '';
			});
			filtered.forEach((el, index) => {
				let optionInfo = el.split('_');
				let checked = index == 0 ? 'checked' : '';
				string += '<div class="form-check form-check-inline"><input class="form-check-input" type="radio" name="addon-option" id="abc' + optionInfo[1] + '" value="' + optionInfo[1] + '" ' + checked + ' /><label class="form-check-label" for="abc' + optionInfo[1] + '">' + optionInfo[0] + ' ( £' + optionInfo[1] + ' ) </label></div>';
			});

			$("#option-fields").html(string);
			$("#option-price-field").show();

		} else {
			$("#option-price-field").hide();
		}

		if (addon.custom_price == '1') {
			$("#custom-price-field").show();

		} else {
			$("#custom-price-field").hide();
		}

		if (addon.lapFieldDisplay == '1') {
			$("#display-laps").attr("data-display", "true");
			$("#display-laps label.col-form-label").html(addon.lapsText);
			$("#display-laps").show();
		} else {
			$("#display-laps").attr("data-display", "false");
			$("#display-laps").hide();
		}
		if (addon.carSelectionDisplay == '1') {
			$("#selected-car-viewer").attr("data-display", "true");
			$("#selected-car-viewer").show();
			$("#display-car-block").attr("data-display", "true");
			$("#display-car-block").show();
			if (addon.only_premium == '1') {
				$('.car-img-wrapper .non-premium').hide();
			} else {
				$('.car-img-wrapper .non-premium').show();
			}

			if (addonSelectedslug === 'extra-laps') {
				$('.car-img-holder .price-badge').hide();
			} else {
				$('.car-img-holder .price-badge').show();
			}

			if (addonSelectedslug === 'extra-car-passenger' || addonSelectedslug === 'extra-car-driving') {
				$('.car-img-wrapper .car-img-holder').each(function (index, element) {
					let newPrice = Number(addon.price) + Number($(element).find('.price-badge').attr('price'));

					if ($(element).find('span').data('premium') == 'premium') {
						if (addon.premium_car_discount) {
							newPrice = newPrice - Number(addon.premium_car_discount);
						}
					}

					$(element).find('.price-badge').html('£' + newPrice);
					$(element).find('span').attr('data-price-car', newPrice);
				});
			} else {
				$('.car-img-wrapper .car-img-holder').each(function (index, element) {
					let newPrice = Number($(element).find('.price-badge').attr('price'));

					if ($(element).find('span').data('premium') == 'premium') {
						if (addon.premium_car_discount) {
							newPrice = newPrice - Number(addon.premium_car_discount);
						}
					}
					$(element).find('.price-badge').html('£' + newPrice);
					$(element).find('span').attr('data-price-car', newPrice);
				});
			}

		} else {
			$("#selected-car-viewer").attr("data-display", "false");
			$("#selected-car-viewer").hide();
			$("#display-car-block").attr("data-display", "false");
			$("#display-car-block").hide();
		}
		$("#add-to-order-btn").attr("data-display", "true");
		$("#add-to-order-btn").show();
	}

	function resetCurrentOrder() {
		doEmptyOrderContainer();
		$("#sub-total").html("£0.0");
		$("#discount-view").html("£0.0");
		$("#total-view").html("£0.0");
		$("#driver-name-input").val('');
		$("#driver-name-holder").html("-")
		$("#current-total").html("£0.0");
		$(".amount-to-pay").val('0.00');
		$(".receipt-email").val('');
		$(".receipt-to-email").prop('checked', false);
		$(".total-due-view").html("£0.0");
		$("#payment-btn").addClass('button-disable');
		$("#payment-btn").removeClass('btn-covey');
		$("#pay-by-cash").removeClass('btn-covey');
		$("#pay-by-card").removeClass('btn-covey');
		$("#orderId").val('0');
		$("#new-amount-to-pay").val('');
		$("#payment-btn").removeAttr('data-toggle');
		$("#payment-btn").removeAttr('data-target');

		discount = 0;
		subtotal = 0;
		total = 0;
		orderItems = {};
		updateCartNumber(0);
		orderVoucherItems = {};
		merchItems= {};
	}

	$('#paymentModal').on('hide.bs.modal', function (event) {

	});

	$('#paymentModal').on('hidden.bs.modal', function (event) {
		$("#order-notification").html('');
		removebetterHighlightNotification()
	});

	function removebetterHighlightNotification() {
		$('#payment-types').removeClass('heightzero');
		$('#order-notification').removeClass('heightfull');
		$('#paymentHtml').removeClass('full');
		$('#addressHtml').removeClass('donotshow');
	}

	function betterHighlightNotification(removeAddress = false) {
		$('#payment-types').addClass('heightzero');
		$('#order-notification').addClass('heightfull');

		if (removeAddress) {
			$('#paymentHtml').addClass('full');
			$('#addressHtml').addClass('donotshow');
		}
	}

	function resetForm() {
		$(".addon-product").css("border", "2px solid #858585");
		$(".addon-product-voucher").css("border", "2px solid #858585");
		$(".addon-product-merch").css("border", "2px solid #858585");
		$("#addon-name-holder").html("Select Addon First");
		$("#car-selected-box").html("<span>Select a Car</span>");
		$("#car-selected-box").removeClass("selected");
		$("#addon-section .car-selection-wrapper").hide();
		$("#display-laps").attr("data-display", "false");
		$("#display-laps").hide();
		$("#custom-laps").val('');
		$("#one").prop('checked', true);
		$("#selected-car-viewer").attr("data-display", "false");
		$("#selected-car-viewer").hide();
		$("#display-car-block").attr("data-display", "false");
		$("#display-car-block").hide();
		$("#add-to-order-btn").attr("data-display", "false");
		$("#add-to-order-btn").hide();
		removeRedBackgroundForCarDisplay();
		removeNotification();
		resetAddonObject();
		resetVoucherObject();
		resetMerchForm();
	}

	$("#custom-laps").keyup(function () {
		if ($(this).val() > 0) {
			$("input[name='laps']").prop('checked', false);
			$(this).addClass('selected');
		} else {
			$("#one").prop('checked', true);
			$(this).removeClass('selected');
		}
	});

	$("input[name='laps']").click(function () {
		$("#custom-laps").removeClass('selected');
		$("#custom-laps").val('');
	})

	function addAddonToSidebar(orderAddon, indexId) {
		let carHtml = '';
		let solder = "<tr><td class='a-label solder' colspan='2' ><i class='fa fa-user' aria-hidden='true'></i>" + orderAddon.soldByName + "</td></tr>";
		let lapHtml = "<tr><td class='a-label'>Quantity</td><td class='a-value'>" + orderAddon.qty + "</td></tr>";
		if (orderAddon.carId != '0') {
			carHtml = "<tr><td class='a-label'>Car</td><td class='a-value'>" + orderAddon.carName + "</td></tr>";
		}
		let addonOptionHolder = "<table class='product-description'>" + carHtml + lapHtml + solder + "</table>";
		let addonHolder = "<div class='row order-item addon-order'  id='" + indexId + "'><div class='col'><h4 class='product-title' data-parent='" + indexId + "' data-indexid='" + indexId + "' ><i class='fa fa-times-circle' aria-hidden='true'></i>" + orderAddon.addonName + "</h4>" + addonOptionHolder + "</div></div>";
		$("#order-item-holder").append(addonHolder);
	}

	$(".taking-order-page").on("click", "#add-to-order-btn", function () {
		let selectedSlug = addonSelectedslug;
		let qty = 1;
		let carId = 0;
		let carName = '';
		let addonPrice = 0;
		let carPremiumPrice = 0;
		let addToOrder = true;

		let soldBy = $("#sold-by-input").val();

		if (soldBy == 0) {
			addToOrder = false;
			$("#sold-by-input").addClass('error');
		} else {
			$("#sold-by-input").removeClass('error');
		}

		let soldByName = $("#sold-by-input option:selected").text();

		if (addonObject.option == '1') {
			addonPrice = Number($("#option-fields input[name=addon-option]:checked").val());
		}

		if (addonObject.custom_price == '1') {

			let CustomPrice = Number($("#custom-price-input").val());
			let CustomItem = $("#custom-item-input").val();
			if (!CustomPrice) {
				$("#custom-price-input").addClass('error');
				addToOrder = false;
			}

			if (!CustomItem) {
				$("#custom-item-input").addClass('error');
				addToOrder = false;
			}

			if (CustomPrice && CustomItem) {
				addonPrice = CustomPrice;
				addonObject.name = CustomItem;
				$("#custom-price-input").val('');
				$("#custom-item-input").val('');
			}
		}


		if (addonObject.lapFieldDisplay == '1') {
			let customLaps = $("#custom-laps").val();
			qty = $("input[name='laps']:checked").val();
			if (!qty) {
				qty = customLaps;
			}
		}

		if (addonObject.carSelectionDisplay == '1') {
			carId = $("#car-selected-box span").attr("data-car-id");
			carName = $("#car-selected-box span").text();
			if (addonObject.add_premium_price) {
				addonPrice = Number($("#car-selected-box span").attr('data-price-car'));

			}
			if (!carId) {
				addToOrder = false;
				$("#car-selected-box").css("background-color", "#ff2525");
			}
		}

		let indexId = getRandomString() + addonObject.id;

		let total_price = (addonPrice != 0) ? addonPrice : addonObject.price;

		if (qty > 0) {
			total_price = total_price * qty;
		}

		total_price = Number(total_price);

		if (addToOrder) {
			let orderAddon = {
				'addonId': addonObject.id,
				'addonName': addonObject.name,
				'price': total_price,
				'qty': qty,
				'carId': carId,
				'carName': carName,
				'slug': selectedSlug,
				'soldById': soldBy,
				'soldByName': soldByName
			}

			addAddonToSidebar(orderAddon, indexId);
			orderItems[indexId] = orderAddon;
			updateViewPrice();
			resetAddonObject();
			resetForm();
		}
	});

	function getRandomString() {
		return (Math.random() + 1).toString(36).substring(7);
	}

	function removeRedBackgroundForCarDisplay() {
		$("#car-selected-box").css("background-color", "transparent");
	}

	function showNotification(message) {
		$("#show-notification").html("<p>" + message + "</p>");
	}

	function removeNotification() {
		$("#show-notification").html("");
	}

	function isAnyVoucherOrderPending() {
		if (ObjectLength_Modern(orderVoucherItems) == 0) {
			return false;
		} else {
			return true;
		}
	}

	$(".taking-order-page").on("click", ".addon-product", function () {
		let voucherOrderExists = isAnyVoucherOrderPending();
		if (voucherOrderExists || ObjectLength_Modern(merchItems) != 0) {
			let question = "Hello ! <br/> You Have To Complete Current Order or Remove its Items.";
			$("#questionHolder").html(question);
			$("#consentBtn").hide();
			$("#closeBtn").html("Close");
			$("#alertModal").modal('show');
		} else {

			resetForm();
			enableDiscountBtn();
			$(".addmore").prop('disabled', false);
			$(this).css("border", "4px solid #ffc107");
			$('#add-to-order-container').show();
			$("#addon-voucher-section").hide();
			$("#addon-section").show();
			$("#addon-section .car-selection-wrapper").show();
			$("#driver-info-row").show();
			if ($("#driver-name-input").val() === '') {
				$("#driver-name-input").focus();
			};
			addonObject = {
				'id': $(this).attr("data-id"),
				'slug': $(this).attr("data-slug"),
				'name': $(this).attr("data-name"),
				'price': $(this).attr("data-price"),
				'lapFieldDisplay': $(this).attr("data-display-laps"),
				'carSelectionDisplay': $(this).attr("data-display-car"),
				'custom_price': $(this).attr("data-custom-price"),
				'only_premium': $(this).attr("data-only-premium-car"),
				'premium_check': $(this).attr("data-premium-car-check"),
				'add_premium_price': $(this).attr("data-add-premium-car-price"),
				'premium_car_discount': $(this).attr("data-premimum-car-discount"),
				'lapsText': $(this).data('laptext'),
				'option': $(this).data("option"),
				'option_details': $(this).data("option-details")
			}
			createFormReady(addonObject);
		}
	});

	$("#driver-name-input").blur(function () {
		let valid = checkInputFieldsForAddonSell();
		if (valid) {
			$(this).removeClass('error');
		}
		if (total > 0) {
			updateViewPrice();
		}
	});

	// $("#sold-by-input").change(function(){
	//     let valid = checkInputFieldsForAddonSell();
	//     if(valid){
	//         $(this).removeClass('error');
	//     }
	//     if(total > 0){
	//         updateViewPrice();
	//     }
	// });

	// $("#sold-by-input-for-voucher").change(function(){
	//     let valid = checkInputFieldsForVouchers();
	//     if(valid){
	//         $(this).removeClass('error');
	//     }
	//     if(total > 0){
	//         updateViewPrice();
	//     }
	// });

	$('.taking-order-page').on('click', '#car-selected-box', function () {
		$('#carSelectionModal').modal();
	})

	$(".taking-order-page").on("click", ".chose-a-car", function () {
		let content = $(this).html();
		$("#car-selected-box").html(content);
		$("#car-selected-box").addClass('selected');
		removeRedBackgroundForCarDisplay();
		$('#carSelectionModal').modal('hide');
	});

	$(".taking-order-page").on("click", ".addmore", function () {
		resetForm();
	});

	$(".price-bar").on("click", '.product-title', function () {
		$("#" + $(this).data("parent")).remove();
		delete orderItems[$(this).data("indexid")];
		updateViewPrice();
	});

	function updateViewPrice() {
		updatePrice();
		$("#sub-total").html("£" + subtotal);
		$("#discount-view").html("£" + discount);
		$("#total-view").html("£" + total);
		$("#current-total").html("£" + subtotal);
		$(".amount-to-pay").val(total);
		$(".total-due-view").html("£" + total);

		if (total > 0) {
			if (ObjectLength_Modern(orderItems) != 0) {
				let validInputs = checkInputFieldsForAddonSell();
				if (validInputs) {
					activePaymentBtn();
				}
			}
			if (ObjectLength_Modern(orderVoucherItems) != 0) {
				let validVoucherInputs = checkInputFieldsForVouchers();
				if (validVoucherInputs) {
					activePaymentBtn();
				}
			}
			if (ObjectLength_Modern(merchItems) != 0) {
				activePaymentBtn();
			}

		} else {
			$("#new-amount-to-pay").val(0);
			$("#payment-btn").removeClass('btn-covey');
			$("#payment-btn").removeAttr('data-toggle');
			$("#payment-btn").removeAttr('data-target');
			discount = 0;
		}
	}

	function activePaymentBtn() {
		$("#payment-btn").prop('disabled', false);
		$("#payment-btn").removeClass('button-disable');
		$("#payment-btn").addClass('btn-covey');
		$("#payment-btn").attr('data-toggle', 'modal');
		$("#payment-btn").attr('data-target', '#paymentModal');
		$("#pay-by-cash").addClass('btn-covey');
		$("#pay-by-card").addClass('btn-covey');
	}

	function updatePrice() {
		let amount = 0;

		let addonCounts = ObjectLength_Modern(orderItems);
		let voucherCounts = ObjectLength_Modern(orderVoucherItems);
		let merchCounts = ObjectLength_Modern(merchItems);


		if (addonCounts != 0) {
			for (var key in orderItems) {
				amount += Number(orderItems[key].price);
			}
		}

		if (voucherCounts != 0) {
			for (var key in orderVoucherItems) {
				let priceDetails = getVoucherTotalPriceWithAddons(key);
				amount += Number(priceDetails.totalPrice + priceDetails.totalAddonPrice);
			}
		}

		if (merchCounts != 0) {
			for (var key in merchItems) {
				amount += parseFloat(merchItems[key].cost);
			}
		}

		subtotal = amount.toFixed(2);

		if (subtotal <= 0) {
			discount = 0;
		}

		total = subtotal - discount;
		total = total.toFixed(2);
		let totalCartItems = addonCounts + voucherCounts + merchCounts;
		updateCartNumber(totalCartItems);
	}

	function updateCartNumber(count) {
		$('#cart-count').html(count);
	}

	$("#new-amount-to-pay").keydown(function (e) {
		if(e.keyCode == 13) {
			e.preventDefault();
			return false;
		}
	})

	$("#new-amount-to-pay").keyup(function () {
		let newAmount = $(this).val();
		$(".total-due-view").html("£" + newAmount);
	});

	$('#editModal').on('show.bs.modal', function () {
		$('#new-amount-to-pay').val('').removeClass('error').trigger('focus');
		$(".total-due-view").html("£" + total);
		if (total <= 0) {
			$("#make-discount-btn").hide();
			$('#new-amount-to-pay').prop('readonly', true);
		} else {
			$("#make-discount-btn").show();
			$('#new-amount-to-pay').prop('readonly', false);
		}
	})

	$("#make-discount-btn").click(function () {
		let totalAfterDiscount = Number($("#new-amount-to-pay").val()).toFixed(2);
		if (totalAfterDiscount > 0) {
			discount = subtotal - Number(totalAfterDiscount);
			discount = discount.toFixed(2);
			$("#edit-modal-cancel-btn").trigger('click');
			//$("#editModal").modal('dispose');
			updateViewPrice();
		//	$("#hero-cart-button").trigger('click');
			//$("#payment-btn").trigger('click');
		} else {
			$("#new-amount-to-pay").addClass('error');
		}
	});

	function ObjectLength_Modern(object) {
		return Object.keys(object).length;
	}

	function validateEmail(email) {
		const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

		return re.test(email);
	}

	function isSameAddress() {
		let sameAddress = 1;
		if ($("#billing-shipping-diff").prop("checked") == true) {
			sameAddress = 0;
		}

		return sameAddress;
	}

	function checkAddresses() {
		let proceed = false;
		let isValidEmail = false;
		let requiredInput = $("#paymentModal .required-input");
		$.each(requiredInput, function (ind, element) {
			let ID = element.attributes[1].value;
			if ($("#" + ID).val() == '') {
				$(this).addClass('error-input');
				proceed = false;
			} else {
				$(this).removeClass('error-input');
				proceed = true;
			}

		});
		let isValidemail = validateEmail($("#billing-email").val());
		if (!isValidemail) {
			isValidEmail = false;
			$("#billing-email").addClass('error-input');
		} else {
			isValidEmail = true;
			$("#billing-email").removeClass('error-input');
		}

		if (!isSameAddress()) {
			let shippingRequiredInput = $(".shipping-required-input");
			$.each(shippingRequiredInput, function (ind, element) {
				let ID = element.attributes[1].value;
				if ($("#" + ID).val() == '') {
					$(this).addClass('error-input');
					proceed = false;
				} else {
					$(this).removeClass('error-input');
					proceed = true;
				}
			});
			let isValidemail = validateEmail($("#shipping-email").val());
			if (!isValidemail) {
				isValidEmail = false;
				$("#shipping-email").addClass('error-input');
			} else {
				isValidEmail = true;
				$("#shipping-email").removeClass('error-input');
			}

			if (!proceed) {
				$(".shipping-tab").addClass('error-input');
			} else {
				$("#paymentModal .shipping-tab").removeClass('error-input');
			}
		} else {
			$("#paymentModal .shipping-required-input").removeClass('error-input');
			$("#paymentModal .shipping-tab").removeClass('error-input');
		}

		//check receipt email
		if (!isReceiptEmailValid('card')) {
			proceed = false;
		}

		if (proceed && isValidEmail) {
			return true;
		} else {
			errorMsg = 'Check Address';
			return false;
		}
	}

	function getAddresses() {
		let shippingAddress = {};
		let sameAddress = 0;
		let billingAddress = {
			'title': $("#billing-title").val(),
			'foreName': $("#billing-forename").val(),
			'sureName': $("#billing-surname").val(),
			'addressLine1': $("#billing-line1").val(),
			'addressLine2': $("#billing-line2").val(),
			'town': $("#billing-town").val(),
			'country': $("#billing-country").val(),
			'postCode': $("#billing-post-code").val(),
			'email': $("#billing-email").val(),
			'phone': $("#billing-phone").val()
		}
		if (isSameAddress()) {
			shippingAddress = billingAddress;
			sameAddress = 1;
		} else {
			shippingAddress = {
				'title': $("#shipping-title").val(),
				'foreName': $("#shipping-forename").val(),
				'sureName': $("#shipping-surname").val(),
				'addressLine1': $("#shipping-line1").val(),
				'addressLine2': $("#shipping-line2").val(),
				'town': $("#shipping-town").val(),
				'country': $("#shipping-country").val(),
				'postCode': $("#shipping-post-code").val(),
				'email': $("#shipping-email").val(),
				'phone': $("#shipping-phone").val()
			}
		}

		return { 'billing': billingAddress, 'shipping': shippingAddress, 'sameAddress': sameAddress };
	}

	$("#pay-by-cash").click(function () {
		let proceed = false;
		let addonOrder = false;
		let voucherOrder = false;
		let merchOrder = false;
		var paymentType = 0;

		if (ObjectLength_Modern(orderItems) > 0) {
			addonOrder = true;
			proceed = true;
		}

		if (ObjectLength_Modern(orderVoucherItems) > 0) {
			paymentType = 1;
			voucherOrder = true;
			proceed = true;
		}

		if (ObjectLength_Modern(merchItems) > 0) {
			merchOrder = true;
			proceed = true;
		}

		if (proceed === true) {
			completeOrder(addonOrder, voucherOrder, merchOrder, paymentType);
		} else {
			errorMsg = 'Check Order !';
			$("#order-notification").html("<div style='width:100%;' class='alert alert-danger'> <i class='fa fa-times' aria-hidden='true'></i> " + errorMsg + " </div>");
		}
	});


	function completeOrder(addonOrder, voucherOrder, merchOrder, paymentType, ref = 'cash') {
		if (voucherOrder === true) {
			if (checkAddresses() === true) {
				//let order_id = existing_order_id;
				//if (!order_id) {
				//  order_id = extractValueFromCookie('OrderId');
				//}
				let items = JSON.stringify(orderVoucherItems);
				let addresses = JSON.stringify(getAddresses());
				let data = {
					"action": "pos",
					"post_action": "store_voucher_order",
					"order_data": { 'items': items, 'discount': discount, 'payment_type': paymentType, 'address': addresses, 'ref': ref, 'email_receipt': getReceiptEmail('cash') }
				}
				$.post(ajaxurl, data, function (response) {
					let result = $.parseJSON(response);
					if (result.data) {
						showVoucherCodesInModal(result.data);
						$("#order-notification").html("<div style='width:100%;' class='alert alert-success'><i class='fa fa-check' aria-hidden='true'></i> Purchase Complete. </div>");
						resetVoucherObject();
						betterHighlightNotification(true);
						resetForm();
						resetCurrentOrder();
						$(".addon-product-voucher").click();
						orderCompleted = true;
					}
				});
			} else {
				$("#order-notification").html("<div style='width:100%;' class='alert alert-danger'> <i class='fa fa-times' aria-hidden='true'></i> " + errorMsg + " </div>");
			}
		}

		if (addonOrder === true) {
			let items = JSON.stringify(orderItems);
			if (checkInputFieldsForAddonSell()) {
				let driver = $("#driver-name-input").val();
				let orderid = $("#orderId").val();
				let voucherid = $("#voucherId").val();
				let data = {
					"action": "pos",
					"post_action": "complete_pos_order",
					"order_data": { 'orderid': orderid, 'voucherid': voucherid, 'items': items, 'discount': discount, 'payment_type': paymentType, 'driver': driver, 'ref': ref, 'email_receipt': getReceiptEmail('cash') }
				}
				$.post(ajaxurl, data, function (response) {
					let result = $.parseJSON(response);
					if (result.data) {
						$("#order-notification").html("<div style='width:100%;' class='alert alert-success'><i class='fa fa-check' aria-hidden='true'></i>  Purchase Complete. </div>");
						betterHighlightNotification();
						resetForm();
						resetCurrentOrder();
						orderCompleted = true;
					}
				});

				if (orderid) {
					$("#orderId").val('');
					$("#voucherId").val('');
					//window.location.replace( window.location.origin + "/pos") ;
				}
			} else {

				$("#order-notification").html("<div style='width:100%;' class='alert alert-danger'><i class='fa fa-times' aria-hidden='true'></i> " + errorMsg + " </div>");
			}
		}

		if (merchOrder === true) {
			let items = JSON.stringify(merchItems);
			let data = {
					"action": "pos",
					"post_action": "complete_merch_order",
					"order_data": { 'items': items, 'discount': discount, 'payment_type': paymentType, 'ref': ref, 'email_receipt': getReceiptEmail('cash') }
			}
			$.post(ajaxurl, data, function (response) {
				let result = $.parseJSON(response);
				if (result.data) {
					$("#order-notification").html("<div style='width:100%;' class='alert alert-success'><i class='fa fa-check' aria-hidden='true'></i>  Purchase Complete. </div>");
					betterHighlightNotification();
					resetForm();
					resetCurrentOrder();
					orderCompleted = true;
				}
			});

		}
	}

	$(".taking-order-page").on("click", ".merch-product select", function (e) {
		e.stopPropagation();
	})

	$(".taking-order-page").on("click", ".merch-product", function (e) {
		let option = $(this).find('select');
		if (option.length) {
			if (option.val()) {
				markMerchSelected($(this), option.val(), option.find('option:selected').text());
				removeMerchError();
			} else {
				addMerchError();
			}
		} else {
			markMerchSelected($(this));
		}
	});

	$(".price-bar").on("click", '.merch-title', function () {
		$("#" + $(this).data("parent")).remove();
		$("#merchid" + $(this).data("itemid")).removeClass('tempselected');
		delete merchItems[$(this).data("indexid")];

		updateViewPrice();
	});

	function addMerchToOrder() {
		//remove all previous
		$('#order-item-holder .addon-order.merch-order').remove();
		if (ObjectLength_Modern(merchItems) > 0) {
			for (var key in merchItems) {
				//add to cart
				let merchOptionHolder = '<table class="product-description"><tbody><tr><td class="a-label">Quantity</td><td class="a-value">1</td></tr></tbody></table>';
				let merchItemHtml = "<div class='row order-item addon-order merch-order'  id='" + key + "'><div class='col'><h4 class='merch-title' data-itemid='" + merchItems[key].item_id + "' data-parent='" + key + "' data-indexid='" + key + "' ><i class='fa fa-times-circle' aria-hidden='true'></i>" + merchItems[key].name + "</h4>" + merchOptionHolder + "</div></div>";

				$("#order-item-holder").append(merchItemHtml);
			}
		}

		updateViewPrice();

	}

	$(".taking-order-page").on('click', '#add-merch-order', function() {
		$( ".merch-product.tempselected" ).each(function( index ) {
			let option = $(this).find('select');
			let name = $(this).data('name');
			let optionId = 0;
			if (option.length) {
				if (option.val()) {
					name = $(this).data('name') + '-' + option.find('option:selected').text();
					optionId = option.val();
				}

			}

			let merch = {
				'item_id': $(this).data('item-id'),
				'name': name,
				'option_id': optionId,
				'cost': $(this).data('cost'),
				'qty': 1
			}

			merchItems[getRandomString()] = merch;
			$(this).removeClass('tempselected');
		});

		addMerchToOrder();
	})

	function markMerchSelected(obj, optionId='', optionName='') {
		if($(obj).hasClass('tempselected')) {
			$(obj).removeClass('tempselected')
		} else {

			$(obj).addClass('tempselected');
		}

	}

	function removeMerchError(){
		$('#merch-error').html('');
	}

	function addMerchError(msg='Select product size first.'){
		$('#merch-error').html(msg);
	}

	function resetMerchForm() {
		$(".addon-product-merch").css("border", "2px solid #858585");
		$('#addon-merch-section').hide();
		$('.merch-product').removeClass('tempselected');
		merchItems = {};
	}

	function showMerchForm() {
		$(".addmore").prop('disabled', true);
		$("#driver-info-row").hide();
		$("#addon-section").hide();
		$("#addon-voucher-section").hide();
		$(".addon-order").remove();
		$('#addon-merch-section').show();
	}

	function makeMerchFormWorkable() {
		resetForm();
		showMerchForm();
		resetAddonObject();
		resetVoucherObject();
		updateViewPrice();
		enableDiscountBtn();
		$(".addon-product-merch").css("border", "4px solid #ffc107");
	}

	$(".taking-order-page").on("click", ".addon-product-merch", function () {
		let showMerchForm = true;
		if (isAnyVoucherOrderPending() || ObjectLength_Modern(orderItems) != 0) {
			let question = "Hello ! <br/> You Have To Complete previous order or Remove items from basket.";
			$("#questionHolder").html(question);
			$("#consentBtn").hide();
			$("#closeBtn").html("Close");
			$("#alertModal").modal('show');
			showMerchForm = false;
		}

		if (showMerchForm) {
			makeMerchFormWorkable();
		}
	});


	$(".taking-order-page").on("click", ".addon-product-voucher", function () {
		let removeCurrentOrder = true;
		if (ObjectLength_Modern(orderItems) > 0 || ObjectLength_Modern(merchItems) > 0) {
			let question = "Hello ! <br/> Do You Think To Skip Current Order ?";
			$("#questionHolder").html(question);
			$("#closeBtn").html("No");
			$("#consentBtn").html("Yes");
			$("#consentBtn").show();
			$("#alertModal").modal('show');
			removeCurrentOrder = false;
		}

		if (isAnyVoucherOrderPending()) {
			removeCurrentOrder = false;
		}

		if (removeCurrentOrder) {
			makeVoucherFormWorkable();
		}
	});

	function makeVoucherFormWorkable() {
		resetForm();
		removeAddOrderUI();
		orderItems = {};
		merchItems= {};
		updateViewPrice();
		createVoucherFormReady();
		$(".addon-product-voucher").css("border", "4px solid #ffc107");
		disableDiscountBtn();
	}

	$("#consentBtn").click(function () {
		makeVoucherFormWorkable();
		$("#alertModal").modal('hide');
	});

	function removeAddOrderUI() {
		$(".addmore").prop('disabled', true);
		$("#driver-info-row").hide();
		$("#addon-section").hide();
		$("#addon-voucher-section").show();
		$(".addon-order").remove();
		$('#add-to-order-container').hide();
	}

	function createVoucherFormReady() {
		$("#addon-voucher-name-holder").html($(".addon-product-voucher").attr('data-name'));
		$('#sold-by-input-for-voucher').prop('selectedIndex', 0);
	}

	function doEmptyOrderContainer() {
		$(".order-item").remove();
	}

	function getCookieExpireTime() {
		var now = new Date();
		now.setDate(now.getDate() + 1);
		now.setHours(0, 0, 1, 0);
		return now.toUTCString();
	}

	function createAddonList(data) {
		for (j = 0; j < data.length; j++) {
			addOnProduct[data[j].addon_id] = { 'price': data[j].price, 'addonid': data[j].addon_id, 'addonname': data[j].name };
		}
	}

	function getAddonList(quantity, ProductId = 0) {
		if (ProductId) {
			voucherProductId = ProductId;
		}
		let html = '';
		let data = {
			"action": "pos",
			"post_action": "get_addon_list_for_voucher",
			"order_data": { 'voucher_product_id': voucherProductId }
		}
		let request = $.post(ajaxurl, data);
		request.promise().done(function (response) {
			let result = $.parseJSON(response);
			if (result.data) {
				if (!$('#voucherModal').is(':visible')) {
					createAddonList(result.data);
				}
				if (quantity) {
					for (let i = 1; i <= quantity; i++) {
						let addons = '';
						let addOnCheckBoxHtml = '';
						for (j = 0; j < result.data.length; j++) {
							addOnCheckBoxHtml += "<div class='col-12 col-md-6 checkbox-row'><input type='checkbox' data-addon-price='" + result.data[j].price + "' data-addon-id='" + result.data[j].addon_id + "' value='" + result.data[j].price + "' id='" + result.data[j].addon_id + i + "' /> <label for='" + result.data[j].addon_id + i + "' >   " + result.data[j].name + "( £" + result.data[j].price + " ) </label></div>"; //"<div class='col-6 checkbox-row'><input type='checkbox' idval='" + $addon_price + "' value='" + $addon->ID + "' id='" .$addon->ID.$key. "' /> <label for='" .$addon->ID.$key. "' > ". $display_name ."(".$addon_price.") </label> </div>";
						}
						if (addOnCheckBoxHtml != '') {
							addons = "<div class='col-12'><div class='row' id='addonHolder" + i + "'>" + addOnCheckBoxHtml + "</div></div>";
						}
						let title = "<div class='col-12 col-form-label'>" + i + ". " + voucherTitle + "</div>";
						let inputField = "<div class='col-12'> <input class='form-input required-input' id='input" + i + "' type='text' placeholder='Name of Voucher Recipient'/></div>";
						let textarea = "<div class='col-12'> <textarea rows='3' class='form-input' id='intextarea" + i + "' placeholder='Message'></textarea></div>";
						let wrapper = "<div class='form-group'> " + title + inputField + textarea + addons + "</div>";
						html += wrapper;
					}
				}
				$("#repeater-part").html(html);
				if ($('#voucherModal').is(':visible')) {
					$("#voucherModal .required-input").removeClass('error-input');
					$("#voucherModal input").val('');
				} else {
					$("#voucherModal").modal('show');
				}
			}
		});
	}

	$(".voucher-product").click(function () {
		voucherTitle = $(this).attr('data-title');
		voucherProductId = $(this).attr('data-post-id');
		voucherPrice = $(this).attr('data-price');
		let soldby = $("#sold-by-input-for-voucher").val();
		let soldbyName = '';
		if (soldby != 0) {
			soldbyName = $("#sold-by-input-for-voucher option:selected").text();
			$("#sold-by-input-for-voucher").removeClass('error');
			getAddonList(1, voucherProductId);

		} else {
			$("#sold-by-input-for-voucher").addClass('error');
		}
	});

	$(".taking-order-page").ready(function () {
		$("#payment-btn").prop('disabled', true);
		createAddonList();
	});

	function extractValueFromCookie(key1) {
		let cookies = document.cookie;
		let cookieObject = cookies.split('; ');
		let data = '';
		$.each(cookieObject, function (i, element) {
			let allCookie = element.split('=');
			if (allCookie[0] === key1) {
				data = allCookie[1];
			}
		});

		return data;
	}

	function getReceiptEmail(selector) {
		if ($('#receipt-on-' + selector).is(':checked')) {
			return $('#receipt-to-email-' + selector).val();
		} else {
			return '';
		}
	}

	function isReceiptEmailValid(selector) {
		if ($('#receipt-on-' + selector).is(':checked')) {
			let validEmail = validateEmail($('#receipt-to-email-' + selector).val());
			if (validEmail) {
				return true;
			} else {
				errorMsg = 'Check Receipt email';
				return false;
			}
		} else {
			return true;
		}
	}

	$('.receipt-to-email').on('click', function () {
		let targetField = '#receipt-to-email-' + $(this).val();
		if ($(this).is(':checked')) {
			$(targetField).addClass('open');
			$(targetField).focus();

		} else {
			$(targetField).removeClass('open');
		}
	});

	$('#billing-email').blur(function () {
		$('.repeipt-email').val($(this).val());
	});

	$("#paymentModal").on('shown.bs.modal', function (event) {

		if (ObjectLength_Modern(orderVoucherItems) > 0) {
			$("#paymentModal .required-input").removeClass('error-input');
			$("#paymentModal .shipping-required-input").removeClass('error-input');
			$("#paymentModal .shipping-tab").removeClass('error-input');
			$("#paymentModal .address-container input").val('');
			$("#addressHtml").show();
			$("#paymentHtml").addClass('right-border').removeClass('col').addClass('col-8');
			$("#inner-payment-options").removeClass('col-10').addClass('col');
			// $("#paymentHtml").css('padding', '50px 0px 140px');
		} else {
			$("#addressHtml").hide();
			$("#paymentHtml").removeClass('right-border').removeClass('col-8').addClass('col');
			$("#inner-payment-options").removeClass('col').addClass('col-10');
			//$("#paymentHtml").css('padding', '50px 14% 140px');
		}

		$('.receipt-to-email').prop('checked', false);
		$('.receipt-email').val('').removeClass('open');

		enabledPaymentButtons();
		//exec stripe token generator
		createToken();
		setPaymentCardSelected();
	});

	$('#paymentModal').on('hidden.bs.modal', function (e) {
		if (orderCompleted) {
			$('.general-form-wrapper select').prop('selectedIndex', 0);
		}
	});

	// function removeElementFromCookie(elementId) {
	//   let voucherOrderId = existing_order_id;
	//   if (voucherOrderId == 0) {
	//     existing_order_id = extractValueFromCookie('OrderId');
	//   }
	//   let data = {
	//     "action": "pos",
	//     "post_action": "remove_item_from_incomplete_voucher_order",
	//     "order_data": { 'order_id': existing_order_id, 'voucher_post_id': elementId }
	//   }
	//   $.post(ajaxurl, data, function (response) {
	//     let result = JSON.parse(response);
	//     if (Number(result.data) === 0) {
	//       resetVoucherObject();
	//       resetOrderId();
	//       resetForm();
	//       resetCurrentOrder();
	//       document.cookie = "OrderId=";
	//     } else {
	//       addOrderVoucherToOrderDetails();
	//     }
	//   });
	// }

	var todaysMerchLogs = $('#todaysMerchLogs').DataTable({
		dom: 'Bfrtip',
		pageLength: 16,
		buttons: [
			'copyHtml5',
			'excelHtml5',
			'csvHtml5',
			'pdfHtml5'
		],
		columns: [
			null,
			null,
			null,
			null,
			{ orderable: false },
			{ orderable: false }
		],
		ajax: {
			url: ajaxurl + '?action=pos&post_action=get_todays_merch_log'
		},
		responsive: true,
	});

	var todaysLogsTable = $('#todaysLogs').DataTable({
		dom: 'Bfrtip',
		pageLength: 16,
		buttons: [
			'copyHtml5',
			'excelHtml5',
			'csvHtml5',
			'pdfHtml5'
		],
		columns: [
			null,
			null,
			null,
			null,
			null,
			null,
			{ orderable: false }
		],
		ajax: {
			url: ajaxurl + '?action=pos&post_action=get_todays_log'
		},
		responsive: true,
	});

	$.fn.dataTable.Api.register('sum()', function () {
		return this.flatten().reduce(function (a, b) {
			if (typeof a === 'string') {
				a = a.replace(/[^\d.-]/g, '') * 1;
			}
			if (typeof b === 'string') {
				b = b.replace(/[^\d.-]/g, '') * 1;
			}

			return a + b;
		}, 0);
	});

	var CommissionLogs = $("#CommissionLogs").DataTable({
		dom: 'Bfrtip',
		buttons: [
			'copyHtml5',
			'excelHtml5',
			'csvHtml5',
			'pdfHtml5'
		],
		ajax: {
			url: ajaxurl + '?action=pos&post_action=get_commissions'
		},
		responsive: true,
		'initComplete': function (settings, json) {
			callbackDatatableFunciton(settings);
		}
	});

	function getCommissionData(startDate, endDate) {
		let start = startDate;
		let end = endDate;
		let commissionDataURL = ajaxurl + '?action=pos&post_action=get_commissions&start=' + start + '&end=' + end + '';
		CommissionLogs.clear();
		CommissionLogs.destroy();
		CommissionLogs = $("#CommissionLogs").DataTable({
			dom: 'Bfrtip',
			buttons: [
				'copyHtml5',
				'excelHtml5',
				'csvHtml5',
				'pdfHtml5'
			],
			ajax: {
				url: commissionDataURL
			},
			responsive: true,
			'initComplete': function (settings, json) {
				callbackDatatableFunciton(settings);
			}
		});
	}

	function callbackDatatableFunciton(settings) {

		var api = new $.fn.dataTable.Api(settings);

		api.columns(1).every(function () {
			$("#total-sold").html('£' + this.data().sum().toFixed(2));
		});

		api.columns(2).every(function () {
			$("#total-commission").html('£' + this.data().sum().toFixed(2));
		});
	}

	$(".commission").on("click", "#getDateRangeCommission", function () {
		getCommissionData(startDate, endDate, true);
		$("#calenderModal").modal('hide');
		$("#page-header").html('<span class="btn btn-back btn-covey" onClick="location.reload();"> << BACK </span>');
	});

	function updateEventList(start = '', end = '', selected = false) {
		var checkin_page = document.getElementById("checkin-page");
		if (checkin_page) {
			let data = {
				"action": "pos",
				"post_action": "get_event_list",
				"filters": { 'start': start, 'end': end }
			}
			let eventAjax = $.post(ajaxurl, data);
			eventAjax.done(function (response) {
				let result = JSON.parse(response);
				$("#select-event").html(result.data.options);
				$("#summary-view").html('Summary : ' + result.data.summary);
				if (selected) {
					$("#select-event #eid" + event_table_val).prop('selected', true);
					setSummary();
				}
			});
		}
	}

	function setSummary() {
		let summary = $("#select-event option:selected").attr('data-summary');
		$("#summary-view").html('Summary : ' + summary);
	}

	$("#checkin-page").ready(function () {
		fp = flatpickr("#dateSelect", config2);
		updateEventList(startDate, endDate);
	});

	$("#dateSelect").change(function () {
		updateEventList(startDate, endDate);
		setEventInfo();
		event_table_key = 0;
		event_table_val = 0;
		eventTableUrl = ajaxurl + '?action=pos&post_action=get_event_checkin_data&from=' + startDate + '&to=' + endDate + '&key=' + event_table_key + '&eid=' + event_table_val;
		EventCheckinTable.ajax.url(eventTableUrl).load();

	});

	var selectedEventId;
	function setEventInfo() {
		event_table_key = $("#select-event option:selected").attr('data-key');
		event_table_val = $("#select-event option:selected").val();
		if (!event_table_key) {
			event_table_key = 0;
		}
		if (!event_table_val) {
			event_table_val = 0;
		}
		eventTableUrl = ajaxurl + '?action=pos&post_action=get_event_checkin_data&from=' + startDate + '&to=' + endDate + '&key=' + event_table_key + '&eid=' + event_table_val;
	}

	$("#select-event").change(function () {
		setEventInfo();
		setSummary();
		EventCheckinTable.ajax.url(eventTableUrl).load();

	});


	eventTableUrl = ajaxurl + '?action=pos&post_action=get_event_checkin_data&from=' + startDate + '&to=' + endDate + '&key=' + event_table_key + '&eid=' + event_table_val;
	EventCheckinTable = $('#EventCheckinTable').DataTable({
		dom: 'Bfrtip',
		pageLength: 5,
		buttons: [
			'pdfHtml5'
		],
		ajax: {
			url: eventTableUrl
		},
		drawCallback: function (settings) {

		}
	});

	$('#EventCheckinTable tbody').on('click', 'tr .sorting_1', function () {
		$("#checkin-error").html('');
		let bookingData = EventCheckinTable.row($(this).closest('tr')).data();
		let booking_name = bookingData[2];
		$("#booking_search_title").html("Search Results");
		$(".isDriverCheckedIn").html(bookingData[1]);
		$("#checkInDrivervoucher").html(bookingData[0]);
		$(".checkInDrivervoucher").html(bookingData[0]);
		$(".checkInDriverName").html(booking_name);
		$(".checkInDriverEmail").html(bookingData[4]);
		$(".checkInDriverCarName").html(bookingData[3]);
		$(".checkInDriverContact").html(bookingData[5]);
		var posLink = '#';

		if (bookingData[0] != '') {
			let order_line_id = $("#checkInDrivervoucher span").data("id");
			let booking_id = $("#checkInDrivervoucher span").data("booking-id");
			let remote_key = $("#checkInDrivervoucher span").data("remote-key");
			let booking_voucher = $("#checkInDrivervoucher span").data("booking-voucher");
			let checkin_status = $("#checkInDrivervoucher span").data("checkedin");
			let number_cars = $("#checkInDrivervoucher span").data("number-cars");
			let product_id = $("#checkInDrivervoucher span").data("product-id");
			manageCheckinCheckout(booking_id, remote_key, checkin_status, booking_voucher);
			$("#detailsModalBtn").attr("booking-id", booking_id);
			$("#detailsModalBtn").attr("remote-key", remote_key);

			posLink = local_site_link.site_url + '/pos/?action=pos&orderid=' + order_line_id + '&voucher=' + booking_voucher + '&key=' + remote_key + '&booking=' + booking_id + '&driver=' + booking_name + '&product_id=' + product_id + '&number_car=' + number_cars;
		}

		$("#checkInAddonBtn").attr("href", posLink);
	});

	function manageCheckinCheckout(booking_id, remote_key, checkin_status, booking_voucher) {
		$("#checkInBtn").attr("booking-id", booking_id);
		$("#checkInBtn").attr("remote-key", remote_key);
		$("#checkInBtn").attr("checkin-status", checkin_status);
		$("#checkInBtn").attr("voucher-code", booking_voucher);
		$("#checkInBtn").addClass('btn-covey');
		if (checkin_status == '0') {
			$("#checkInBtn").text('Check In');

		} else {

			$("#checkInBtn").text('Check Out');
		}
	}

	$("#checkInBtn").click(function () {

		let booking_id = $(this).attr("booking-id");
		let remote_key = $(this).attr("remote-key");
		let voucher_key = $(this).attr("voucher-code");
		var checkin_status = $(this).attr("checkin-status");
		var btn_text = 'Select First';
		if (booking_id) {
			setEventInfo();
			let data = {
				"action": "pos",
				"post_action": "let_driver_checkin",
				"booking_data": { "id": booking_id, "key": remote_key, "status": checkin_status, 'voucher_key': voucher_key }
			}
			$.post(ajaxurl, data, function (response) {

				let result = $.parseJSON(response);
				if (result.data) {
					$('#EventCheckinTable').DataTable().search('');
					var action_done = '';

					if (checkin_status == '0') {
						action_done = 'Checked In';
					} else {
						action_done = 'Checked Out';
					}
					$("#checkin-error").html(action_done + ' ! ');

				} else {
					$("#checkin-error").html('Action not completed ! Select booking Again !');
				}
				EventCheckinTable.ajax.url(eventTableUrl).load();
				updateEventList(startDate, endDate, true);
			});
			$("#checkInBtn").text(btn_text);
			$("#checkInBtn").removeClass('btn-covey');
			$("#checkInBtn").attr("booking-id", '');
			$("#checkInBtn").attr("remote-key", '');
			$("#checkInBtn").attr("checkin-status", '');
		} else {
			$("#checkin-error").html("No Bookings Selected To Check In ! ");
		}
	});

	$("#detailsModalBtn").click(function () {
		let booking_id = $(this).attr("booking-id");
		let remote_key = $(this).attr("remote-key");
		if (booking_id) {
			let data = {
				"action": "pos",
				"post_action": "get_booking_details_data",
				"booking_data": { "id": booking_id, "key": remote_key }
			}
			$.post(ajaxurl, data, function (response) {
				let result = $.parseJSON(response);
				if (result.data) {
					$("#booking-details-cars").html(result.data.car_details);
					$("#bookings-details-addons").html(result.data.addons);
					$("#booking-other-details").html(result.data.other_details);
					$("#third-party-voucher").html(result.data.other_voucher_code);
				}
			});
			$("#customerDetailsModal").modal('show');
		} else {
			$("#checkin-error").html("No Bookings Selected To Show ! ");
		}
	});

	$('#customerDetailsModal').on('shown.bs.modal', function (event) {

		$("#show-modal-notification").html("");
		$("#checkin-note").val('');
		$("#checkin-note").focus();
		$("#customerDetailsModal").on("keyup", "#checkin-note", function () {
			if ($(this).val() != '') {
				$("#btn-add-comment").addClass('btn-warning');
			} else {
				$("#btn-add-comment").removeClass('btn-warning');
			}
		});

		$("#btn-add-comment").click(function () {
			$("#btn-add-comment").prop('disable', true);
			let note = $("#checkin-note").val();
			if (note != '') {
				let voucherCode = $("#voucherCodeHolder span").attr('booking-voucher');
				let remote_key = $("#voucherCodeHolder span").attr('remote-key');
				let data = {
					"action": "pos",
					"post_action": "add_comment_on_checkin",
					"comment_data": { 'key': remote_key, 'voucher_code': voucherCode, 'comment': note }
				}
				$.post(ajaxurl, data, function (response) {

					let result = $.parseJSON(response);
					if (result.data) {
						$("#show-modal-notification").html("<div class='alert alert-success'>Comment Added !</div>");
						$("#checkin-note").val('');
						$("#btn-add-comment").removeClass('btn-warning');
						$("#btn-add-comment").prop('disable', false);
					}
				});
			} else {
				$("#show-modal-notification").html("<div class='alert alert-danger'>No comment to add !</div>");
			}
		});
	});

	/** Staff Portal Events */
	var myEventsUrl = ajaxurl + '?action=pos&post_action=my_requested_events&filter=true';
	var myEvents = $("#myEvents").DataTable({
		dom: 'rtip',
		ajax: {
			url: myEventsUrl
		}
	});

	$('#show-all-events').click(function () {
		var myEventsUrlFilter = ajaxurl + '?action=pos&post_action=my_requested_events&filter=';
		myEvents.ajax.url(myEventsUrlFilter).load();
		$(this).html('Showing all').prop('disabled', true);
	})


	var paymentUrl = ajaxurl + '?action=pos&post_action=get_pos_payments&start=&end=';
	PaymentTable = $('#PaymentDataTable').DataTable({
		dom: 'Bfrtip',
		pageLength: 10,
		buttons: [
			'pdfHtml5'
		],
		order: [[0, 'desc']],
		columns: [
			null,
			{ orderable: false },
			{ orderable: false },
			{ orderable: false },
			null,
			{ orderable: false },
			{ orderable: false },
		],
		ajax: {
			url: paymentUrl
		},
		responsive: true,
	});

	$('#PaymentDataTable').on('click', '.make-refund', function () {
		$('#output-msg').html($(this).data('warning-msg'));
		$('#order-ref').val($(this).data('order-ref'));
		$('.modal-footer').css('display', 'flex');

		$('#paymentDetailsModal').modal();
	});


	$('#paymentDetailsModal').on('click', '#request-cancel', function () {
		$('#output-msg').html('Doing cancel...');
		$('.modal-footer').css('display', 'none');
		let payment_id = $('#order-ref').val();

		if (payment_id) {
			let data = {
				"action": "pos",
				"post_action": "cancel_pos_order",
				"filters": { "order_ref": payment_id }
			}
			$.post(ajaxurl, data, function (response) {
				let result = $.parseJSON(response);
				if (result.data.status) {
					PaymentTable.ajax.reload();
					$('#paymentDetailsModal #exampleModalLabel').html('<i class="fa fa-check" aria-hidden="true"></i> ' + result.data.message);
					$('#paymentDetailsModal').modal('hide');
				} else {
					$('#output-msg').html('Something went wrong...');
					$('.modal-footer').css('display', 'flex');
				}
			});
		}
	});

	var deletedOrderUrl = ajaxurl + '?action=pos&post_action=get_deleted_pos_orders&start=&end=';
	DeletePaymentTable = $('#DeletedOrdersDataTable').DataTable({
		dom: 'Bfrtip',
		pageLength: 10,
		buttons: [
			'pdfHtml5'
		],
		columns: [
			null,
			null,
			null,
			null,
			null,
			{ orderable: false },
			{ orderable: false }
		],
		ajax: {
			url: deletedOrderUrl
		},
		responsive: true,
	})

	$(document).on('keyup', '.table-container input[type=search]', function () {
		if ($(this).val()) {
			$(this).addClass('clearBG');
		} else {
			$(this).removeClass('clearBG');
		}
	})

	/***    Stripe Terminal Payment  ***/
	var terminal;
	var cardPaymentDone = false;
	var finalNotification;
	var lastEverNotification = '';
	var stopPayment = false;
	var backToCheckout = false;

	//this funciton will be called each time payment modal shown
	function createToken() {
		//console.log('creating new token...');
		terminal = StripeTerminal.create({
			onFetchConnectionToken: fetchConnectionToken,
			onUnexpectedReaderDisconnect: unexpectedDisconnect,
		});
	}

	function fetchConnectionToken() {
		//console.log('token funciton called');
		let data = {
			"action": "tca_stripe_terminal",
			"post_action": "get_connection_token"
		}

		return $.post(ajaxurl, data).then(function (response) {
			//console.log(response);
			result = $.parseJSON(response);
			return result.data;
		})
			.then(function (data) {
				//console.log(data);
				//console.log(data.secret);
				return data.secret;
			});
	}

	function unexpectedDisconnect() {
		// You might want to display UI to notify the user and start re-discovering readers
		//console.log('Terminal Disconnected !');
		backToCheckout = true;
		changeNotification('Terminal Disconnected... ', '#f00', true, backToCheckout);
	}

	function reconnectAndRestart() {
		//console.log('Riconnecting...');
		connectReaderHandler();
	}

	// Handler for a "Connect Reader" button
	function connectReaderHandler() {
		//console.log(getOrderData());

		changeNotification('Searching for terminal...', '#ff9900');
		//var config = {simulated: true};
		const config = { simulated: false, location: getLocation() }
		terminal.discoverReaders(config).then(function (discoverResult) {
			//console.log('discover result ....');
			//console.log(discoverResult);
			if (discoverResult.error) {
				//console.log('Failed to discover: '+discoverResult.error);
				backToCheckout = true;
				changeNotification('Failed to discover terminal ... ', '#f00', true, backToCheckout);
			} else if (discoverResult.discoveredReaders.length === 0) {
				//console.log('No available Terminal...');
				backToCheckout = true;
				changeNotification('No available terminal ... ', '#f00', true, backToCheckout);
			} else {
				// Just select the first reader here.
				//console.log(discoverResult);
				//possible to discover reader
				// for now just select the first
				var selectedReader = discoverResult.discoveredReaders[0];
				//console.log('terminal selected');
				changeNotification('Terminal Selected.', '#26a142');
				//get terminal status
				let terminalStatus = terminal.getConnectionStatus();
				if (terminalStatus == 'connecting' || terminalStatus == 'connected') {
					//console.log('There is a previous connection ...so...disconnecting...');
					terminal.disconnectReader();
					createToken();
					reconnectAndRestart();
				} else {
					//cancelled processing ? ..
					if (!stopPayment) {
						//fail_if_in_use : true -  your application does not interrupt a reader that’s currently collecting a payment
						//if false - your application connects to the other application’s reader immediately. If the other application is currently collecting payment, that payment fails with an unexpected disconnect.
						terminal.connectReader(selectedReader, { fail_if_in_use: true }).then(function (connectResult) {
							//console.log('connecting to terminal...');
							changeNotification('Connecting to Terminal...', '#ff9900');
							if (connectResult.error) {
								//console.log(connectResult.error.message);
								backToCheckout = true;
								changeNotification('Failed to connect ', '#f00', true, backToCheckout);
							} else {
								//console.log('Connected to reader: '+ connectResult.reader.label);
								changeNotification('Connected. Processing with ' + connectResult.reader.label, '#26a142');
								//create payment intent
								if (!stopPayment) {
									createPaymentSessionIntent();
								} else {
									changeNotification('Payment Cancelled...', '#f00', true, true);
								}
							}
						});
					} else {
						changeNotification('Payment Cancelled...', '#f00', true, true);
					}
				}
			}
		});
	}

	function createPaymentSessionIntent() {
		//console.log('start session ');
		//date will be based on ready order on screen
		let data = {
			"action": "tca_stripe_terminal",
			"post_action": "create_payment_session",
			"data": getOrderData()
		}

		$.post(ajaxurl, data).then(function (response) {
			result = $.parseJSON(response);
			//console.log(result);
			return result.data;
		})
			.then(function (data) {
				//console.log('Client Secrect: '+data);
				//console.log(data);
				//return data.client_secret;
				if (data.status) {
					return checkout(data.client_secret);
				} else {
					backToCheckout = true;
					//console.log('stripe exception on payment session creation..');
					changeNotification('Server Connection Error.', '#f00', true, backToCheckout);
				}
			});
	}

	function checkout(clientSecret) {
		// clientSecret is the client_secret from the PaymentIntent you created in Step 1.
		//console.log('get payment status....');
		//console.log(terminal.getPaymentStatus());
		// Status READY.
		//payment not cancelled ??....
		if (!stopPayment) {

			terminal.collectPaymentMethod(clientSecret).then(function (result) {
				if (result.error) {
					// Placeholder for handling result.error
					//console.log('Error 1 : ');
					//console.log(result.error);
					backToCheckout = true;
					changeNotification('Error...', '#f00', true, backToCheckout);
				} else {
					// Placeholder for processing result.paymentIntent
					// console.log('get payment status....');
					//console.log(terminal.getPaymentStatus());
					// console.log('Result 1 : ');
					// console.log(result);
					//This point start taking payment.....so remove cancel button....
					if (!stopPayment) {
						changeNotification('Processing Payment...', '#26a142', true);
						terminal.processPayment(result.paymentIntent).then(function (result) {
							if (result.error) {
								// Placeholder for handling result.error
								backToCheckout = true;
								finalNotification = 'There\'s been an issue with card payment !';

								if (result.error.code == 'card_declined' || 'expired_card' || 'processing_error') {
									changeNotification(finalNotification, '#f00', true, backToCheckout);
								} else {
									changeNotification('Payment Failed...', '#f00', true, backToCheckout);
								}

								terminal.disconnectReader();
								//console.log('Terminal Disconnected..');
								//console.log(result.error);

							} else if (result.paymentIntent) {
								// Placeholder for notifying your backend to capture result.paymentIntent.id
								//console.log(result.paymentIntent.id);
								changeNotification('Completing Payment...', '#176629', true);
								let data = {
									"action": "tca_stripe_terminal",
									"post_action": "capture_payment",
									"data": getOrderData(),
									"intent": result.paymentIntent.id,
								}

								$.post(ajaxurl, data).then(function (response) {

									result = $.parseJSON(response);
									//console.log('final result: ');
									//console.log(response);
									let results = result.data;
									let colour = '#ed6804';
									if (results.status) {
										if (results.payment_success == true && results.order_saved == true) {
											colour = '#176629';
											finalNotification = '<i class="fa fa-check fa-2x" aria-hidden="true"></i><br/>Payment succeeded and order saved ! <br/> Touch anywhere for next order.';
										} else if (results.payment_success == true && results.order_saved == false) {
											finalNotification = '<i class="fa fa-question fa-2x" aria-hidden="true"></i><br/>Payment succeeded and order not saved';
										} else if (results.payment_success == false && results.order_saved == true) {
											finalNotification = '<i class="fa fa-question fa-2x" aria-hidden="true"></i><br/>Payment failed and order saved';
										} else {
											colour = '#f00';
											finalNotification = '<i class="fa fa-exclamation fa-2x" aria-hidden="true"></i><br/>Payment failed and order failed';
										}
									} else {
										//console.log('Stripe Exception on finialize payment.');
										changeNotification('Payment not completed. Server error.', '#f00', true, true);
									}
									cardPaymentDone = true;
									changeNotification(finalNotification, colour, true);

									setTimeout(() => {
										changeNotification('Closing this window...', '#000', true);

									}, 3000);

									setTimeout(() => {
										execPostOrderActivity();
									}, 5000);

								});
							}
						});
					} else {
						changeNotification('Payment Cancelled...', '#f00', true, true);
					}
				}
			});
		} else {
			changeNotification('Payment Cancelled...', '#f00', true, true);
		}
	}

	//To start handle the payment call   funciton connectReaderHandler;
	/** Stripe Terminal End */

	function resetAddonActiveOrder() {
		resetForm();
		resetCurrentOrder();
		let orderid = $("#orderId").val();
		if (orderid) {
			$("#orderId").val('');
			$("#voucherId").val('');
		}
	}

	function resetVoucherActiveOrder() {
		resetVoucherObject();
		//resetOrderId();
		resetForm();
		resetCurrentOrder();
		document.cookie = "OrderId=";
	}

	function resetMerchActiveOrder() {
		resetMerchForm()
		resetForm();
		resetCurrentOrder();
	}

	$('.terminal-payment-body').click(function () {
		execPostOrderActivity();
	});

	function execPostOrderActivity() {

		if (cardPaymentDone) {

			if (ObjectLength_Modern(orderItems) > 0) {
				resetAddonActiveOrder();
			}

			if (ObjectLength_Modern(orderVoucherItems) > 0) {
				resetVoucherActiveOrder();
			}

			if (ObjectLength_Modern(merchItems) > 0) {
				resetMerchActiveOrder();
			}

			DeactiveTerminalNotificationUi();
			enabledPaymentButtons();

			$('#paymentModal').modal('hide');
			$('#show-notification').html('<p>' + lastEverNotification + '<p>');

		} else {
			//enable buttons
			enabledPaymentButtons();
			$("#order-notification").html("<div style='width:100%;' class='alert alert-warning'> <i class='fa fa-times' aria-hidden='true'></i> Payment Failed ! </div>");
		}
	}

	$('.terminal-payment-body').on('click', '#backToCheckoutBtn', function () {
		cancelStripePaymentProcessing();
	});

	$('.terminal-payment-body').on('click', '#cancelPaymentProcessing', function () {
		//console.log('Cancel btn called......back to checkout ');
		stopPayment = true;
		lastEverNotification = 'Payment Cncelled ! ';
		//back to chekout...
		cancelStripePaymentProcessing();

	});

	function cancelStripePaymentProcessing() {
		if (terminal.getConnectionStatus() != 'not_connected') {
			terminal.disconnectReader();
		}
		createToken();
		DeactiveTerminalNotificationUi();
		enabledPaymentButtons();
		$("#order-notification").html("<div style='width:100%;' class='alert alert-warning'> <i class='fa fa-times' aria-hidden='true'></i>  Payment Failed ! </div>");

	}

	function disablePaymentButtons() {
		$('form .btn-covey').prop('disabled', true);
	}

	function enabledPaymentButtons() {
		//console.log('btn enable called.........');
		$('form .btn-covey').prop('disabled', false);
	}

	function changeNotification(text = '', colour = '#ffc107', hideCancel = false, startAgain = false) {
		$('#notification-holder').css('color', colour);
		$('#notification-holder').html('<div>' + text + '</div>');
		lastEverNotification = text;

		/* if(animate ==''){
				$('#notification-holder').removeClass('animate-charcter');
		}else{
				$('#notification-holder').addClass('animate-charcter');
		}*/

		if (startAgain) {
			$('#notification-holder').append('<button id="backToCheckoutBtn" class="btn btn-lg btn-covey">BACK TO CHECKOUT</button>');
			//console.log('Terminated ...');
		}

		if (!hideCancel) {
			$('#notification-holder').append('<button id="cancelPaymentProcessing" class="btn btn-lg btn-red">CANCEL PAYMENT</button>');
		}
	}

	function activeTerminalNotificationUi() {
		$('#paymentModal .modal-header').css('display', 'none');
		$('#paymentModal .modal-body').css('display', 'none');
		$('.terminal-payment-body').show();
		changeNotification('Processing payment With terminal...', '', true);
	}

	function DeactiveTerminalNotificationUi() {
		changeNotification('', '', true);
		$('#paymentModal .modal-header').css('display', 'block');
		$('#paymentModal .modal-body').css('display', 'block');
		$('.terminal-payment-body').hide();
	}

	function getOrderData() {

		if (ObjectLength_Modern(orderItems) > 0) {
			let driver = $("#driver-name-input").val();
			let orderid = $("#orderId").val();
			let voucherid = $("#voucherId").val();
			let paymentType = 1;
			let items = JSON.stringify(orderItems);

			return {
				'orderid': orderid,
				'voucherid': voucherid,
				'items': items,
				'discount': discount,
				'payment_type': paymentType,
				'driver': driver,
				'order_type': 'addon',
				'total': total,
				'email_receipt': getReceiptEmail('card')
			};
		}

		if (ObjectLength_Modern(orderVoucherItems) > 0) {
			let order_id = existing_order_id;
			if (!order_id) {
				order_id = extractValueFromCookie('OrderId');
			}
			let addresses = JSON.stringify(getAddresses());
			let items = JSON.stringify(orderVoucherItems);

			return {
				'order_id': order_id,
				'discount': discount,
				'items': items,
				'payment_type': 0,
				'total': total,
				'address': addresses,
				'order_type': 'voucher',
				'email_receipt': getReceiptEmail('card')
			}
		}

		if (ObjectLength_Modern(merchItems) > 0) {
			let order_id = existing_order_id;
			if (!order_id) {
				order_id = extractValueFromCookie('OrderId');
			}
			let items = JSON.stringify(merchItems);

			return {
				'order_id': order_id,
				'discount': discount,
				'items': items,
				'total': total,
				'payment_type': 1,
				'order_type': 'other',
				'email_receipt': getReceiptEmail('card')
			}
		}
	}

	$("#pay-by-card").click(function () {
		let proceed = false;
		let addonOrder = false;
		let voucherOrder = false;
		let merchOrder = false;
		let paymentType = 1;
		//check if it is addon
		if (ObjectLength_Modern(orderItems) > 0) {
			addonOrder = true;
			proceed = true;
		}
		//check if voucher
		if (ObjectLength_Modern(orderVoucherItems) > 0) {
			paymentType = 0;
			voucherOrder = true;
			proceed = true;
		}
		//check if merch
		if (ObjectLength_Modern(merchItems) > 0) {
			merchOrder = true;
			proceed = true;
		}

		if (proceed === true) {
			let prefered_card = getPreferredPaymentCard();
			if ( (prefered_card != 'w' || prefered_card != 'z') && getLocation() != '') {
				// stripe reader selected
				stopPayment = false;
				// go for voucher order
				if (voucherOrder === true) {
					if (checkAddresses() === true) {
						//disable all payment button
						disablePaymentButtons();
						//enable notification for card payment
						activeTerminalNotificationUi();
						//call terminal handler
						connectReaderHandler();
					} else {
						$("#order-notification").html("<div style='width:100%;' class='alert alert-danger'> <i class='fa fa-times' aria-hidden='true'></i> " + errorMsg + " </div>");
					}
				}
				// go for addon order
				if (addonOrder === true) {
					if (checkInputFieldsForAddonSell()) {
						//disable other payment button
						disablePaymentButtons();
						//enable notification for card payment
						activeTerminalNotificationUi();
						//call terminal handler
						connectReaderHandler();
					} else {
						$("#order-notification").html("<div style='width:100%;' class='alert alert-danger'><i class='fa fa-times' aria-hidden='true'></i> " + errorMsg + " </div>");
					}
				}
				// go for merch order
				if (merchOrder === true) {
					if (checkInputFieldsForMerch()) {
						//disable other payment button
						disablePaymentButtons();
						//enable notification for card payment
						activeTerminalNotificationUi();
						//call terminal handler
						connectReaderHandler();
					} else {
						$("#order-notification").html("<div style='width:100%;' class='alert alert-danger'><i class='fa fa-times' aria-hidden='true'></i> " + errorMsg + " </div>");
					}
				}
			} else {
				//zettle or worldpay Payment Selected
				//so complete order as like as cash payment but payment type different
				let card_name = prefered_card == 'z' ? 'zettle' : 'worldpay';
				completeOrder(addonOrder, voucherOrder, merchOrder, paymentType, card_name); // payment type 0 will be card in cash contex
			}

		} else {
			errorMsg = 'Check Order';
			$("#order-notification").html("<div style='width:100%;' class='alert alert-danger'> <i class='fa fa-times' aria-hidden='true'></i> " + errorMsg + " </div>");
		}
	});

	$('#select-card-type').change(function () {
		setPreferredPaymentCard();
		$('#order-notification').html('<div class="alert alert-success">Peferred Card Changed !</div>');
	});

	function setPreferredPaymentCard() {
		document.cookie = "PaymentCard=" + $('#select-card-type').val() + "; expires=" + getCookieExpireTime();
		document.cookie = "Location=" + $('#select-card-type option:selected').attr('lid') + "; expires=" + getCookieExpireTime();
	}

	function getPreferredPaymentCard() {
		return extractValueFromCookie('PaymentCard');
	}

	function getLocation() {
		return extractValueFromCookie('Location');
	}

	function setPaymentCardSelected() {
		//console.log( document.cookie);
		let preSelectedCard = extractValueFromCookie('PaymentCard');
		//console.log(preSelectedCard);
		if (preSelectedCard) {
			$('#select-card-type').val(preSelectedCard);
			$('#select-card-type').css('background', '#e9e9e9');
		} else {
			setPreferredPaymentCard();
			setPaymentCardSelected();
		}
	}

	/********************************* */
	/***    Voucher  Sell              */
	/********************************* */

	function showVoucherCodesInModal(vouchers) {
		let voucherContent = '';
		if (vouchers) {
			for (let i = 0; i < vouchers.length; i++) {
				voucherContent += '<div class="voucher">' + Number(i + 1) + '. <span>' + vouchers[i] + '</span></div>';
			}
		}
		$('#voucherContent').html(voucherContent);
		$('#showVoucherModal').modal();
	}

	$('#showVoucherModal').on('hidden.bs.modal', function (e) {
		$('#voucherContent').html();
	})

	$('#showVoucherModal .custom-logo-link').click(function (e) {
		e.preventDefault();
	})

	function enableDiscountBtn() {
		$('#price-bar').removeClass('voucher-cart');
		if (ObjectLength_Modern(orderVoucherItems) == 0) {
			$('.price-bar .order-modify-buttons .edit').css('visibility', 'visible').css('pointer-events', 'all');
		}
	}

	function disableDiscountBtn() {
		$('#price-bar').addClass('voucher-cart');
		if (ObjectLength_Modern(orderVoucherItems) != 0) {
			$('.price-bar .order-modify-buttons .edit').css('visibility', 'hidden').css('pointer-events', 'none');
		}
	}

	// hide price-bar on open any modal
//	$('.modal').on('show.bs.modal', function(event) {
//		$('#price-bar').removeClass('open');
//	});

	$('#hero-cart-button').on('click', function() {
		$('#price-bar').toggleClass('open');
		$('body').toggleClass('cart-view');
	});

	$(".price-bar").on("click", ".incomplete-voucher-order", function () {
		let indexOrder = $(this).attr("data-index-order").toString();
		if (delete orderVoucherItems[indexOrder]) {
			$(".price-bar #" + indexOrder).remove();
		}
		updateViewPrice();
	});

	$("#voucherModal").on('show.bs.modal', function (event) {
		$("#order-quantity").prop('selectedIndex', 0);
	});

	$("#voucherModal").on('shown.bs.modal', function (event) {
		$("#order-quantity").change(function () {
			let quantity = $(this).val();
			getAddonList(quantity);
		});
	});

	function getVoucherTotalPriceWithAddons(index) {
		let voucher = orderVoucherItems[index];
		let voucherTotalPrice = voucher.qty * voucher.selectedVoucherInfo.price;
		let addonTotalPrice = 0;
		let addonQty = 0;
		$.each(voucher.driversInfo, function (index, element) {
			$.each(element.addonSelected, function (i, e) {
				addonQty++;
				addonTotalPrice += e.price;
			})
		})

		return { 'totalPrice': voucherTotalPrice, 'qty': voucher.qty, 'totalAddonPrice': addonTotalPrice, 'addonQty': addonQty }
	}

	function voucherOrderFromValidation() {
		let proceed = false;
		let requiredInput = $("#voucherModal .required-input");
		$.each(requiredInput, function (ind, element) {
			let ID = element.attributes[1].value;
			if ($("#" + ID).val() == '') {
				$(this).addClass('error-input');
				proceed = false;
			} else {
				$(this).removeClass('error-input');
				proceed = true;
			}
		});

		return proceed;
	}

	$("#voucherModal").on('click', '#AddVoucherDetailsToOrder', function () {
		if (voucherOrderFromValidation() === true) {
			let order_qty = $("#order-quantity").val();
			let voucher_type_id = $("#voucher_type").val();
			let voucherInfo = { 'title': voucherTitle, 'id': voucherProductId, 'price': voucherPrice };
			let driverInfo = {};
			let voucherDriversElements = $("#repeater-part").children();
			$.each(voucherDriversElements, function (index, element) {
				let usingIndex = index + 1;
				let addonSelectedForThisDriver = $("#addonHolder" + usingIndex + " input[type=checkbox]:checked");

				let selectedAddonInfo = {};
				$.each(addonSelectedForThisDriver, function (i, elem) {
					selectedAddonInfo[elem.getAttribute("data-addon-id")] = addOnProduct[elem.getAttribute("data-addon-id")];
				});
				driverInfo[index] = {
					'driverName': $("#input" + usingIndex).val(),
					'driverMessage': $("#intextarea" + usingIndex).val(),
					'addonSelected': selectedAddonInfo
				}
			});

			let soldby = $("#sold-by-input-for-voucher").val();
			let soldbyName = $("#sold-by-input-for-voucher option:selected").text().trim();

			let voucher = {
				'qty': order_qty,
				'voucher_type_id': voucher_type_id,
				'selectedVoucherInfo': voucherInfo,
				'driversInfo': driverInfo,
				'soldbyId': soldby,
				'soldbyName': soldbyName
			}

			let indexId = getRandomString();
			orderVoucherItems[indexId] = voucher;
			addOrderVoucherToOrderDetails(voucher, indexId);
			$("#voucherModal").modal('hide');
			disableDiscountBtn();
		}
	});

	function addOrderVoucherToOrderDetails(voucher, indexId) {
		let priceDetails = getVoucherTotalPriceWithAddons(indexId);

		let order = '<div class="row order-item voucher-order" data-soldby="' + voucher.soldbyName + '" id="' +
			indexId + '"><div class="col"><h4 class="incomplete-voucher-order" data-index-order="' +
			indexId + '"> 50% Voucher <i class="fa fa-times-circle" aria-hidden="true"></i> </h4><table class="product-description"><tbody><tr><td class="a-label">' +
			voucher.selectedVoucherInfo.title + '</td><td class="a-value">' +
			priceDetails.qty + '</td></tr><tr><td class="a-label">Price</td><td class="a-value">£' +
			priceDetails.totalPrice + '</td></tr><tr><td class="a-label">Addons ( ' +
			priceDetails.addonQty + ' )</td><td class="a-value">£' +
			priceDetails.totalAddonPrice + '</td></tr></tbody></table></div></div>';

		$("#order-item-holder").append(order);
		updateViewPrice();
		$(".addon-product-voucher").click();


		//resetVoucherObject();
		//doEmptyOrderContainer();
		// let voucherOrderId = existing_order_id;
		// if (voucherOrderId == 0) {
		//   existing_order_id = extractValueFromCookie('OrderId');
		// }
		// if (existing_order_id != 0) {
		//   let data = {
		//     "action": "pos",
		//     "post_action": "get_incomplete_voucher_order",
		//     "order_data": { 'order_id': existing_order_id }
		//   }
		//$.post(ajaxurl, data, function (response) {
		// let result = JSON.parse(response);
		//if (result.data) {
		//let result2 = JSON.parse(result.data);
		//for (let i = 0; i < result2.item.length; i++) {
		//let voucherOrder = { 'price': result2.total };
		//orderVoucherItems[result2.order_id] = voucherOrder;
		//let product_post_id = result2.item[i].product_post_id;
		//let order = '<div class="row order-item voucher-order" id="' + product_post_id + '"><div class="col"><h4 class="incomplete-voucher-order" data-parent="' + product_post_id + '"> 50% Voucher <i class="fa fa-times-circle" aria-hidden="true"></i> </h4><table class="product-description"><tbody><tr><td class="a-label">' + result2.item[i].name + '</td><td class="a-value">' + result2.item[i].qty + '</td></tr><tr><td class="a-label">Price</td><td class="a-value">£' + result2.item[i].price + '</td></tr><tr><td class="a-label">Addons ( ' + result2.item[i].addon_qty + ' )</td><td class="a-value">£' + result2.item[i].addon + '</td></tr></tbody></table></div></div>';
		//$("#order-item-holder").append(order);
		//}
		//updateViewPrice();
		// }
		// });
		//$(".addon-product-voucher").click();
		//}
	}



	$("#todaysLogs").on("click", ".delete-order", function () {
		let question = "Do You Think To Delete The Order of Amount<br/> <span>" + $(this).data('ordertotal') + "</span>?";
		let string = '<div class="col"><p id="questionHolder">' + question + '</p></div>';
		string += '<input type="hidden" id="selectedOrderId" value="' + $(this).data('orderid') + '" />';
		$("#alertModalLabel").html($(this).data('ordertotal') + '!');
		$("#alertModal .modal-body").html(string);
		$("#alertModal .modal-footer").html('<button type="button" class="btn btn-covey" id="closeBtn" data-dismiss="modal">No</button><button type="button" class="btn" id="logsconsentBtn">Yes</button>');
		$("#alertModal").modal('show');
	});

	$('#emailModal').on('show.bs.modal', function (event) {
		var element = $(event.relatedTarget);
		var orderId = element.data('orderid');
		var orderName = element.data('ordername');
		var orderAmount = element.data('orderamount');
		$('#orderid').val(orderId);
		$('#drivername').val(orderName);
		$('#orderamount').val(orderAmount);
		let orderInfo = '<span>Order Amount: <b>' + orderAmount + '</b></span><span>Driver: <b>' + orderName + '</b></span>';
		$('#order-details').html(orderInfo);
	});

	$('#emailModal #sendMail').on('click', function (e) {
		var email = $('#email').val();
		var orderID = $('#orderid').val();
		var name = $('#drivername').val();
		let data = {
			"action": "pos",
			"post_action": "send_receipt_after_sale",
			"filters": { 'order_id': orderID, 'email': email, 'name': name }
		}
		let adminAjax = $.post(ajaxurl, data);
		adminAjax.done(function (response) {
			let result = JSON.parse(response);
			if (result.data) {
				$('#emailModalLabel').html('<i class="fa fa-check" aria-hidden="true"></i> Email Sent.');
				$('#emailModal .modal-body').hide();
				$('#emailModal .modal-footer').hide();
			}
		});

	});

	$("#alertModal").on('click', '#logsconsentBtn', function () {
		let selectedOrderId = $("#selectedOrderId").val();
		//console.log(selectedOrderId);
		$("#logsconsentBtn").hide();
		$("#questionHolder").html('');
		$("#alertModalLabel").html('Deleting....');
		$("#closeBtn").html("Close");
		$("#closeBtn").addClass("btn-block");
		let data = {
			"action": "pos",
			"post_action": "delete_pos_order",
			"filters": { 'order_id': selectedOrderId }
		}
		let adminAjax = $.post(ajaxurl, data);
		adminAjax.done(function (response) {
			//console.log(response);
			$("#alertModalLabel").html('<i class="fa fa-check" aria-hidden="true"></i> Deleted.');
			location.reload();
		});
	});


	$('#merchDetailsModal').on('show.bs.modal', function (event) {
		var element = $(event.relatedTarget);
		var orderId = element.data('orderid');
		$('#merchDetailsModal #total').html('Order total: £' + element.data('total'));
		$('#merchDetailsModal #discount').html('Discount: £' + element.data('discount'));
		var modal = $(this);
		let data = {
			"action": "pos",
			"post_action": "retrive_pos_merch_order",
			"filters": { 'order_id': orderId }
		}
		let adminAjax = $.post(ajaxurl, data);
		adminAjax.done(function (response) {
			let result = JSON.parse(response);
			$('#details-content').html(result.data);

		});
	});

	$('#logEditModal').on('show.bs.modal', function (event) {
		var element = $(event.relatedTarget);
		var orderId = element.data('orderid');
		var modal = $(this);
		//get full order
		//console.log(orderId);
		let data = {
			"action": "pos",
			"post_action": "retrive_pos_order",
			"filters": { 'order_id': orderId }
		}
		let adminAjax = $.post(ajaxurl, data);
		adminAjax.done(function (response) {
			let result = JSON.parse(response);
			$('#order-info').html(result.data.order_html);
			$('#order-line-info').html(result.data.lines_html);
		});
	});

	$('#logEditModal').on('hide.bs.modal', function (event) {
		location.reload();
	})

	$('#emailModal').on('show.bs.modal', function (event) {
		var element = $(event.relatedTarget);
		var orderId = element.data('orderid');
		var orderName = element.data('ordername');
		var orderAmount = element.data('orderamount');
		$('#orderid').val(orderId);
		$('#drivername').val(orderName);
		$('#orderamount').val(orderAmount);
		let orderInfo = '<span>Order Amount: <b>' + orderAmount + '</b></span><span>Driver: <b>' + orderName + '</b></span>';
		$('#order-details').html(orderInfo);
	});

	$('#logEditModal').on('click', '#btn-order-update', function () {

		$("#alertModalLabel").html('Confirmation');
		$("#closeBtn").html("No");
		let string = '<div class="col"><p id="questionHolder">Are you sure to update ?</p></div>';
		string += '<input type="hidden" id="currentOrderId" value="' + $(this).data('orderid') + '" />';

		$("#alertModal .modal-body").html(string);
		$("#alertModal .modal-footer").html('<button type="button" class="btn btn-covey" id="closeBtn" data-dismiss="modal">No</button><button type="button" class="btn" id="consentBtn">Yes</button>');
		$("#alertModal").modal('show');
	});

	$('#alertModal').on('click', '#consentBtn', function () {
		let currentOrderId = $("#currentOrderId").val();
		let data = {
			"action": "pos",
			"post_action": "update_pos_order",
			"filters": {
				'order_id': currentOrderId,
				'discount': $('#inputdiscount').val(),
				'driver': $('#inputdriver').val()
			}
		}
		let adminAjax = $.post(ajaxurl, data);
		adminAjax.done(function (response) {
			let result = JSON.parse(response);
			if (result.data) {
				$("#alertModal").modal('hide');
				$('#order-info-title').html(' (Updated!)');
				$('#order-info').html(result.data.order_html);
			}
		});
	});

	$('#logEditModal').on('click', '.btn-ol-delete', function () {
		let string = '<div class="col"><p id="questionHolder">Are you sure to Delete ?</p></div>';

		$("#alertModalLabel").html('Confirmation');
		$("#closeBtn").html("No");
		string += '<input type="hidden" id="OrderId" value="' + $(this).data('orderid') + '" /><input type="hidden" id="OrderLineId" value="' + $(this).data('lineid') + '" />'
		$("#alertModal .modal-body").html(string);
		$("#alertModal .modal-footer").html('<button type="button" class="btn btn-covey" id="closeBtn" data-dismiss="modal">No</button><button type="button" class="btn" id="consentOlBtnDelete">Yes</button>');
		$("#alertModal").modal('show');
	});

	$('#alertModal').on('click', '#consentOlBtnDelete', function () {
		let currentOrderLineId = $("#OrderLineId").val();
		let currentOrderId = $("#OrderId").val();
		let data = {
			"action": "pos",
			"post_action": "update_pos_order_lines",
			"filters": {
				'order_line_id': currentOrderLineId,
				'order_id': currentOrderId,
				'action': 'delete'
			}
		}

		let adminAjax = $.post(ajaxurl, data);
		adminAjax.done(function (response) {
			let result = JSON.parse(response);
			//console.log(result);
			if (result.data) {
				$("#alertModal").modal('hide');
				$('#order-info-title').html(' (Updated!)');
				$('#order-line-info-title').html(' (Updated!)');
				//$('#order-line-info').html(result.data.lines_html);
				$('#order-info').html(result.data.order_html);
				$('#order-line-info').html(result.data.lines_html);
			}
		});
	});

	$('#logEditModal').on('click', '.btn-ol-update', function () {
		let string = '<div class="col"><p id="questionHolder">Are you sure to update ?</p></div>';
		string += '<input type="hidden" id="OrderId" value="' + $(this).data('orderid') + '" /><input type="hidden" id="OrderLineId" value="' + $(this).data('lineid') + '" />'

		$("#alertModal .modal-body").html(string);
		$("#alertModalLabel").html('Confirmation');
		$("#closeBtn").html("No");
		$("#alertModal .modal-footer").html('<button type="button" class="btn btn-covey" id="closeBtn" data-dismiss="modal">No</button><button type="button" class="btn" id="consentOlBtn">Yes</button>');
		$("#alertModal").modal('show');
	});

	$('#alertModal').on('click', '#consentOlBtn', function () {
		let currentOrderLineId = $("#OrderLineId").val();
		let currentOrderId = $("#OrderId").val();
		let parentRowId = '#row' + currentOrderLineId;
		let addonVal = $(parentRowId).find('.inputaddon').val();
		let soldBy = $(parentRowId).find('.inputsoldby').val();
		let addonCost = $(parentRowId).find('.inputcost').val();
		let data = {
			"action": "pos",
			"post_action": "update_pos_order_lines",
			"filters": {
				'order_line_id': currentOrderLineId,
				'order_id': currentOrderId,
				'cost': addonCost,
				'soldby': soldBy,
				'addon': addonVal,
				'action': 'update'
			}
		}

		let adminAjax = $.post(ajaxurl, data);
		adminAjax.done(function (response) {
			let result = JSON.parse(response);
			if (result.data) {
				$("#alertModal").modal('hide');
				$('#order-info-title').html(' (Updated!)');
				$('#order-line-info-title').html(' (Updated!)');
				//$('#order-line-info').html(result.data.lines_html);
				$('#order-info').html(result.data.order_html);
				$('#order-line-info').html(result.data.lines_html);
			}
		});
	});

	$(document).on('click', '#DeletedOrdersDataTable .delete-record', function () {
		let string = '<div class="col"><p id="questionHolder">Are you sure to Delete ?</p></div>';
		string += '<input type="hidden" id="rowRecordId" value="' + $(this).data('id') + '" />'

		$("#alertModal .modal-body").html(string);
		$("#alertModalLabel").html('Confirmation');
		$("#closeBtn").html("No");
		$("#alertModal .modal-footer").html('<button type="button" class="btn btn-covey" id="closeBtn" data-dismiss="modal">No</button><button type="button" class="btn" id="recordDeleteconsentBtn">Yes</button>');
		$("#alertModal").modal('show');
	});

	$('#alertModal').on('click', '#recordDeleteconsentBtn', function () {

		let currentRecordId = $("#rowRecordId").val();
		let data = {
			"action": "pos",
			"post_action": "delete_pos_record_permanently",
			"filters": {
				'record_id': currentRecordId
			}
		}

		let adminAjax = $.post(ajaxurl, data);
		adminAjax.done(function (response) {
			$('#alertModal').modal('hide');
			let result = JSON.parse(response);

			if (result.success) {
				if (result.data) {
					$('#row' + currentRecordId).parent('td').parent('tr').fadeOut();
				}
			}
		});
	});

	/** End */

})(jQuery);
